"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ARAZZO_VERSIONS_SUPPORTED_BY_SPOT = exports.VERSION_PATTERN = void 0;
exports.VERSION_PATTERN = /^1\.0\.\d+(-.+)?$/;
exports.ARAZZO_VERSIONS_SUPPORTED_BY_SPOT = ['1.0.0'];
